export default "__VITE_ASSET__Dqxi1At6__"